// extracted by mini-css-extract-plugin
export default {"wrapper":"IAG6_oDOCNOOGXu4HYhM","label":"ByPOr4B9li77v00ovjLc","filters":"b4FvK1YhM1uQDY9kh94M","filterBtn":"KUpdjdc2Rd5J6HWfGRAM","periodsPicker":"dBYiOw5CM8x3_TlqB5Ne"};